<template>
	<div v-cloak>
		<div v-if="initialLoading" v-html="loadingShellHtml"></div>
		<div id="main" class="catalogue-shell container-fluid mb-5" v-else>
			<div v-if="loadingError" class="alert alert-danger" role="alert">
				Could not load bundles. <button class="btn btn-outline-danger btn-sm" @click="loadStartup">Try again</button>
			</div>

			<div class="row row-main">
				<div class="col-12 col-md-auto search-controls no-select">

					<div class="filter-switch-section" v-show="mobileOptions.showFilterButton" @click="showFiltersButtonClicked">
						<img class="svg-loader" :src="graphicPlaceholder" data-graphic="/img/loaders/spinner-1s-200px-purple.svg" v-show="requestsActive" />
						<img class="svg-filter" :src="filterIcon" v-show="!requestsActive" />
						<span v-show="!requestsActive">Show Filters</span>
					</div>

					<div class="control-sections" v-show="mobileOptions.showSearchControls">
						<div class="control-section control-section-top" :class="{ 'control-section-only': !hasVisibleFilterSections }">
							<label class="form-label" :class="clsCollapsed(S_SEARCH)" @click="toggleSection(S_SEARCH)">Search Canva Bundles</label>
							<div class="control-section-controls" v-show="showControlSection(S_SEARCH)">
								<input type="text" class="form-control search-input" placeholder="E.g. fitness, yoga, hair" ref="search-input" v-model="bundleSearch.searchTerm" @input="debounceSearchBundlesPZ($event)" @keyup.enter="debounceSearchBundlesPZ($event)" :disabled="disableControls">
							</div>
						</div>
						<div class="control-section control-section-middle" v-show="containsNonZero(bundleCounts.instagram, bundleCounts.facebook)">
							<label class="form-label" :class="clsCollapsed(S_SMTYPE)" @click="toggleSection(S_SMTYPE)">Social Media</label>
							<div class="control-section-controls" v-show="showControlSection(S_SMTYPE)">
								<div class="form-check" v-show="notZero(bundleCounts.instagram)">
									<input class="form-check-input" type="checkbox" :value="smInstagram" v-model="bundleSearch.socialMediaTypes" id="sm-instagram" :disabled="disableControls" @change="searchBundlesPZ">
									<label class="form-check-label no-select" for="sm-instagram">Instagram ({{bundleCounts.instagram}})</label>
								</div>
								<div class="form-check" v-show="notZero(bundleCounts.facebook)">
									<input class="form-check-input" type="checkbox" :value="smFacebook" v-model="bundleSearch.socialMediaTypes" id="sm-facebook" :disabled="disableControls" @change="searchBundlesPZ">
									<label class="form-check-label no-select" for="sm-facebook">Facebook ({{bundleCounts.facebook}})</label>
								</div>
							</div>
						</div>
						<div class="control-section control-section-middle" v-show="containsNonZero(bundleCounts.discounted, bundleCounts.free)">
							<label class="form-label" :class="clsCollapsed(S_PRICE)" @click="toggleSection(S_PRICE)">Pricing</label>
							<div class="control-section-controls" v-show="showControlSection(S_PRICE)">
								<div class="form-check" v-show="notZero(bundleCounts.discounted)">
									<input class="form-check-input" type="checkbox" v-model="bundleSearch.discounted" id="pr-discounted" :disabled="disableControls" @change="searchBundlesPZ">
									<label class="form-check-label no-select" for="pr-discounted">Discounted ({{bundleCounts.discounted}})</label>
								</div>
								<div class="form-check" v-show="notZero(bundleCounts.free)">
									<input class="form-check-input" type="checkbox" v-model="bundleSearch.free" id="pr-free" :disabled="disableControls" @change="searchBundlesPZ">
									<label class="form-check-label no-select" for="pr-free">Free ({{bundleCounts.free}})</label>
								</div>
							</div>
						</div>
						<div class="control-section control-section-bottom" v-show="notZeroBundlesInEach(bundleCategories)">
							<label class="form-label" :class="clsCollapsed(S_CAT)" @click="toggleSection(S_CAT)">Categories</label>
							<div class="control-section-controls" v-show="showControlSection(S_CAT)">
								<div class="form-check" v-for="(bundleCategory, i) in bundleCategories" v-show="notZero(getNrBundles(bundleCategory))">
									<input class="form-check-input" type="checkbox" :value="bundleCategory.id" v-model="bundleSearch.bundleCategoryIDs" :id="getBundleCategoryCheckboxID(bundleCategory)" :disabled="disableControls" @change="searchBundlesPZ">
									<label class="form-check-label no-select" :for="getBundleCategoryCheckboxID(bundleCategory)">{{bundleCategory.name}} ({{getNrBundles(bundleCategory)}})</label>
								</div>
							</div>
						</div>
					</div>

					<div class="show-results-section" v-show="mobileOptions.showResultsButton" @click="showResultsButtonClicked">
						<img class="svg-loader" :src="graphicPlaceholder" data-graphic="/img/loaders/spinner-1s-200px-white.svg" v-show="requestsActive" />
						<span v-show="!requestsActive">Show {{pageOptions.nrRecords}} Bundles</span>
					</div>

				</div>

				<div class="col-12 col-md search-results" v-show="mobileOptions.showSearchResults">

					<div class="row row-paginator-top catalogue-paginator" v-show="searchCompleted">
						<div class="col-paginator-top col-12">
							<paginator v-model="pageOptions.pageIndex" v-bind="pageOptions" :hide-paginator="false" @paginate="searchBundles" :disabled="requestsActive"></paginator>
						</div>
					</div>

					<div class="row row-container-bundles no-select">
						<div class="col-container-bundle col-sm-12 col-lg-6 col-xl-4" v-for="(oBundle, i) in oBundles">
							<div class="container-bundle grow shadow">
								<a class="stylless-link" :href="oBundle.url">
									<div class="bundle-thumb">
										<img class="bundle-image" :src="getFeaturedImageUrl(oBundle)" :alt="getFeaturedImageAlt(oBundle)" :width="getFeaturedImageWidth(oBundle)" :height="getFeaturedImageHeight(oBundle)" :loading="i < visibleImageCount ? 'eager' : 'lazy'" :fetchpriority="i === 0 ? 'high' : 'auto'" />
										<div class="bundle-new-badge" v-show="bundleIsNew(oBundle)" aria-label="New bundle">
											<img src="/img/badges/new-splatter.svg" alt="" aria-hidden="true" loading="lazy" />
											<span>New!</span>
										</div>
										<!-- Disabled brand overlay; retained here for optional restoration: <img class="icon-social-media" :src="getSocialMediaIconUrl(oBundle)" :title="getSocialMediaIconTitle(oBundle)" v-show="false" /> -->
										<!-- Disabled brand overlay; retained here for optional restoration: <img class="icon-content-type" :src="getContentTypeIconUrl(oBundle)" :title="getContentTypeIconTitle(oBundle)" v-show="false" /> -->
									</div>
									<div class="bundle-title">
										<span>{{oBundle.name}}</span>
									</div>
									<div class="bundle-discount" v-show="isDiscountedAndUnowned(oBundle)">
										<timer :seconds="timerNrSeconds(oBundle)" @ended="timerEnded(oBundle)"></timer><span>&nbsp;-&nbsp;{{discountPercentage(oBundle)}} OFF!</span>
									</div>
									<div class="bundle-icons" v-show="false">
										<div class="bundle-icon" :title="getTitleNrDaysSincePublication(oBundle)">
											<img src="/img/packages/clock.svg" loading="lazy" />
											<span>{{oBundle.nrDaysSincePublication}}</span>
										</div>
										<div class="bundle-icon" :title="getTitleNrViews(oBundle)">
											<img src="/img/packages/eye.svg" loading="lazy" />
											<span>{{oBundle.nrViews}}</span>
										</div>
									</div>
									<div class="bundle-cta-button">
										<input type="button" :value="getTextSelectionButton(oBundle)" class="btn btn-primary cta-button">
									</div>
								</a>
							</div>
						</div>
					</div>

					<div class="row row-paginator-bottom" v-show="nonZeroResults">
						<div class="col-paginator-bottom col-12">
							<paginator v-model="pageOptions.pageIndex" v-bind="pageOptions" :hide-paginator="false" @paginate="searchBundles" :disabled="requestsActive"></paginator>
						</div>
					</div>

					<div class="overlay no-select" v-show="requestsActive">
						<div class="overlay-bg"></div>
						<div class="overlay-img"><img :src="graphicPlaceholder" data-graphic="/img/loaders/spinner-1s-200px-purple.svg" /></div>
					</div>

				</div>

			</div> <!-- main row -->
		</div> <!-- container fluid -->
	</div> <!-- vue app -->
</template>




<script>
	import filterIcon from '@/img/icons/filter.svg?inline';
	import { graphicPlaceholder } from '@/js/shared/utils/graphics';
	import '@/scss/graphics/Loaders.scss';
	import { mixinAxios } from '@/js/shared/VueMixins.js';
	// import components
	import paginator from './common/Paginator.vue';
	import timer from './common/Timer.vue';
	import { debounce, getNrSecsUntilSerializedUtcEnd, getUrlSubDirByIndex, toCustomBase64, versionedImageUrl } from '@/js/shared/utils/common';
	import { countDecimals, rangeCap, toFixedNumber, toNrDecimals } from '@/js/shared/utils';
	import { getInitialCatalogueSearch } from '@/js/shared/utils/catalogueStartup';
	import loadingShellHtml from '../../Views/Front/_CatalogueLoading.cshtml?raw';

	// constants
	const S_SEARCH = 0;
	const S_SMTYPE = 1;
	const S_PRICE  = 2;
	const S_CAT    = 3;

	const PAGESIZE    = 9; // todo: must also be set in BundleSearch.cs; make both depend on single setting, instead
	const MS_DEBOUNCE = 250;
	const MOBILE_BP   = 768;

	export default {
		mixins: [mixinAxios],
		components: {
			paginator,
			timer
		},
		data: () => ({
			filterIcon,
			graphicPlaceholder,
			initialLoading: true,
			loadingError: false,
			loadingShellHtml,
			resizeHandler: null,
			mobileOptions: {
				prevWidth : window.innerWidth,
				curWidth : window.innerWidth,
				mobileMode : true,
				showFilterButton : true,
				showResultsButton : false,
				showSearchControls : false,
				showSearchResults : true
			},
			pageOptions: {
				options: {
					texts: {
						countMultiPage: 'Showing {from} to {to} of {count} bundles.',
						countSinglePage: '{count} Bundles.',
						countSingleItem: '1 Bundle.'
					}
				},
				nrRecords: 0,
				pageSize: PAGESIZE,
				pageIndex: 0,
				pageSetSize: 10,
				disabled: false,
				hidePaginator: false
			},
			bundleSearch: {
				searchTerm: '',
				and: true,
				bundleCategoryIDs: [],
				socialMediaTypes: [],
				bundleTypes: [],
				free: false,
				discounted: false,
				pageSize: PAGESIZE,
				pageIndex: 0
			},
			collapsedSections: {
				search : false,
				smType: false,
				price : false,
				cat : false,
			},
			enumBundleType: {},
			enumSocialMediaType: {},
			bundleCategories: [],
			newBundleBadgeNrDays: 14,
			oVisitorStatus: {},
			ownedBundleIDs: {},
			wListedBundleIDs: {},
			oBundles: [],
			searchCompleted: false,
			bundleCounts : {
				instagram: 0,
				facebook: 0,
				discounted: 0,
				free: 0
			},
			debouncedSearchBundlesPZHandler: null
		}),
		props: {
			bundleSearchModel : { type: Object, required: false, default: null },
			bundleSearchStartup : { type: Object, required: false, default: null }
		},
		created() {
			this.initAppropriateMode();
			this.initResizeTracker();
			this.initConstants();
			this.initDebouncedActions();
		},
		beforeUnmount() {
			this.debouncedSearchBundlesPZHandler?.cancel?.();
			removeEventListener('resize', this.resizeHandler);
		},
		mounted() {
			this.initBundleSearch(); // in mounted, so that paginator responds to pageIndex change
			this.loadStartup();
		},
		methods: {
			initResizeTracker() {
				this.resizeHandler = (event) => {
					this.mobileOptions.curWidth = window.innerWidth;
				};
				addEventListener('resize', this.resizeHandler);
			},
			initConstants() {
				this.S_SEARCH = S_SEARCH;
				this.S_SMTYPE = S_SMTYPE;
				this.S_PRICE  = S_PRICE;
				this.S_CAT    = S_CAT;
			},
			initDebouncedActions() {
				this.debouncedSearchBundlesPZHandler = debounce(() => {
					this.searchBundlesPZ();
				}, MS_DEBOUNCE);
			},
			initBundleSearch() {
				this.bundleSearch = this.bundleSearchStartup?.search ?? getInitialCatalogueSearch(this.bundleSearchModel);
				this.pageOptions.pageIndex = this.bundleSearch.pageIndex;
				this.pageOptions.pageSize = this.bundleSearch.pageSize;
			},
			applySearchInfo(data) {
				this.enumBundleType       = data.enumBundleType;
				this.enumSocialMediaType  = data.enumSocialMediaType;
				this.bundleCategories    = data.bundleCategories;
				this.newBundleBadgeNrDays = data.newBundleBadgeNrDays ?? 14;
				this.oVisitorStatus       = data.visitorStatus;
				this.ownedBundleIDs       = data.ownedBundleIDs;
				this.wListedBundleIDs     = data.wListedBundleIDs;
			},
			applySearchResults(data) {
				this.pageOptions.nrRecords = data.paginatedBundles.nrRecords;
				this.oBundles = data.paginatedBundles.entities;
				this.bundleCounts = data.bundleCounts;
				this.searchCompleted = true;
			},
			async loadStartup() {
				this.initialLoading = true;
				this.loadingError = false;
				try {
					const prefetched = this.bundleSearchStartup?.promise;
					if (this.bundleSearchStartup) this.bundleSearchStartup.promise = null;
					const result = prefetched ? await prefetched
						: await this.mixinAxios().post('/api/guest/GetBundlesSearchStartup', this.bundleSearch);
					if (result.error) throw result.error;
					this.applySearchInfo(result.data.searchInfo);
					this.applySearchResults(result.data.searchResults);
					this.updateUrl();
				} catch {
					this.loadingError = true;
				} finally {
					this.initialLoading = false;
				}
			},
			updateUrl() {
				var rootSlug = getUrlSubDirByIndex(0);
				var result   = toCustomBase64(this.bundleSearch);

				var query = (result.success && (this.filtersNotCleared || this.pageIndexNotZero))
					? `/${rootSlug}/${result.b64}/`
					: `/${rootSlug}/`;

				history.replaceState({}, document.title, `${query}${window.location.search}`);
			},
			_searchBundles(evt) {
				this.updateUrl();

				return this.mixinAxios().post('/api/guest/SearchBundlesPaginated', this.bundleSearch)
					.then((result) => {
						this.applySearchResults(result.data);
						this.loadingError = false;
						this.$refs['search-input']?.focus({ preventScroll: true });
					}).catch(() => { this.loadingError = true; });
			},
			searchBundles(evt) {
				// the 'pageOptions.pageIndex' watcher does not update the bundleSearch object quickly enough, so do it manually
				this.bundleSearch.pageIndex = this.pageOptions.pageIndex;
				return this._searchBundles();
			},
			searchBundlesPZ(evt) {
				// PZ = page zero
				this.pageOptions.pageIndex = 0;
				return this.searchBundles(evt);
			},
			debounceSearchBundlesPZ(e) {
				var enter = (e.key === 'Enter');

				if (enter) {
					this.debouncedSearchBundlesPZHandler?.cancel?.();
					return this.searchBundlesPZ(e);
				}

				return this.debouncedSearchBundlesPZHandler();
			},
			getBundleCategoryCheckboxID(bundleCategory) {
				return `id-cb-cat-${bundleCategory.id}`;
			},
			getFeaturedImageUrl(oBundle) {
				var image = oBundle?.images[0];
				return versionedImageUrl(image?.img500Url, image?.imgOriSha1);
			},
			getFeaturedImageAlt(oBundle) {
				return oBundle?.name;
			},
			getFeaturedImageWidth(oBundle) {
				return oBundle?.images[0]?.img500Width;
			},
			getFeaturedImageHeight(oBundle) {
				return oBundle?.images[0]?.img500Height;
			},
			getBundleSocialMediaName(oBundle) {
				return this.enumSocialMediaType?.byValue?.[oBundle?.socialMediaType]?.description ?? null;
			},
			getBundleContentTypeName(oBundle) {
				return this.enumBundleType?.byValue?.[oBundle?.bundleType]?.name ?? null;
			},
			getSocialMediaIconUrl(oBundle) {
				var name = this.getBundleSocialMediaName(oBundle);

				switch (name) {
					case 'Instagram' : return '/img/icons/large/instagram.png';
					case 'Facebook'  : return '/img/icons/large/facebook.png';
					default          : return null;
				}
			},
			getContentTypeIconUrl(oBundle) {
				var name = this.getBundleContentTypeName(oBundle);

				switch (name) {
					case 'Canva'     : return '/img/icons/large/canva.png';
					default          : return null;
				}
			},
			getSocialMediaIconTitle(oBundle) {
				var name = this.getBundleSocialMediaName(oBundle);

				switch (name) {
					case 'Instagram' : return 'Instagram bundle.';
					case 'Facebook'  : return 'Facebook bundle.';
					default          : return null;
				}
			},
			getContentTypeIconTitle(oBundle) {
				var name = this.getBundleContentTypeName(oBundle);

				switch (name) {
					case 'Canva'     : return 'Canva bundle.';
					default          : return null;
				}
			},
			isOwned(oBundle) {
				return (this.ownedBundleIDs?.[oBundle?.id] != null);
			},
			isDiscounted(oBundle) {
				return (oBundle.activeDiscountPeriod != null);
			},
			parseSerializedUtcDate(dateTime) {
				if (!dateTime) {
					return null;
				}

				var strDateTime = dateTime.toString();
				var hasTimeZone = /(?:Z|[+-]\d{2}:?\d{2})$/i.test(strDateTime);
				var normalizedDateTime = (hasTimeZone)
					? strDateTime
					: `${strDateTime}Z`;
				var date = new Date(normalizedDateTime);

				return (Number.isNaN(date.getTime()))
					? null
					: date;
			},
			bundleIsNew(oBundle) {
				var nrDays = Number(this.newBundleBadgeNrDays ?? 0);

				if (nrDays <= 0) {
					return false;
				}

				var publishedOn = this.parseSerializedUtcDate(oBundle?.publishedOn);
				var msNewWindow = nrDays * 24 * 60 * 60 * 1000;

				return (publishedOn != null) && (publishedOn.getTime() >= (Date.now() - msNewWindow));
			},
			discountTimeLeft(oBundle) {
				return (this.timerNrSeconds(oBundle) > 0);
			},
			isDiscountedAndUnowned(oBundle) {
				var unOwned    = !this.isOwned(oBundle);
				var discounted = this.isDiscounted(oBundle);
				var timeLeft   = this.discountTimeLeft(oBundle);

				return (unOwned && discounted && timeLeft);
			},
			discountPercentage(oBundle) {
				var percentage = (this.isDiscounted(oBundle))
					? 100 - ((oBundle.activeDiscountPeriod.nrCredits / oBundle.nrCredits) * 100)
					: 0;

				var nrDecs = rangeCap(countDecimals(percentage), 0, 0) ?? 0;
				return (percentage != null) ? `${toFixedNumber(percentage, nrDecs)}%` : '';
			},
			timerNrSeconds(oBundle) {
				return (this.isDiscounted(oBundle))
					? getNrSecsUntilSerializedUtcEnd(oBundle.activeDiscountPeriod?.end)
					: 0;
			},
			timerEnded(oBundle) {
				oBundle.activeDiscountPeriod = null;
			},
			getTitleNrDaysSincePublication(oBundle) {
				var strDays = (oBundle.nrDaysSincePublication == 1) ? 'day' : 'days';
				return `This bundle was published ${oBundle.nrDaysSincePublication} ${strDays} ago.`;
			},
			getTitleNrViews(oBundle) {
				return `This bundle has been viewed ${oBundle.nrViews} times.`;
			},
			getTextSelectionButton(oBundle) {
				// conditions
				var loggedOut   = !this.isLoggedIn;
				var loggedIn    = !loggedOut;
				var owned       = this.isOwned(oBundle);
				var unowned     = !owned;
				var nrCredits   = oBundle?.actualNrCredits ?? 0;
				var nrTemplates = oBundle?.nrTemplates ?? 0;
				var free        = (nrCredits == 0);
				var paid        = (nrCredits > 0);

				// strings
				var strPrice  = `$${toNrDecimals(nrCredits, 2, 2)}`;
				var strPrefix = `${nrTemplates} Templates - `;
				var strFree   = 'FREE';
				var strOwned  = 'OWNED';

				// return value
				return (loggedOut && paid)
					? strPrefix + strPrice
					: (loggedOut && free)
					? strPrefix + strFree
					: (loggedIn && unowned && paid)
					? strPrefix + strPrice
					: (loggedIn && unowned && free)
					? strPrefix + strFree
					: (loggedIn && owned)
					? strPrefix + strOwned
					: 'VIEW'; // should never be hit
			},
			toggleSection(section) {
				if (section == this.S_SEARCH) {
					this.collapsedSections.search = !this.collapsedSections.search;
				}
				if (section == this.S_SMTYPE) {
					this.collapsedSections.smType = !this.collapsedSections.smType;
				}
				if (section == this.S_PRICE) {
					this.collapsedSections.price = !this.collapsedSections.price;
				}
				if (section == this.S_CAT) {
					this.collapsedSections.cat = !this.collapsedSections.cat;
				}
			},
			clsCollapsed(section) {
				return {
					'collapsed' :
						((section == this.S_SEARCH) && (this.collapsedSections.search)) ||
						((section == this.S_SMTYPE) && (this.collapsedSections.smType)) ||
						((section == this.S_PRICE) && (this.collapsedSections.price)) ||
						((section == this.S_CAT) && (this.collapsedSections.cat))
				};
			},
			showControlSection(section) {
				switch (section)
				{
					case this.S_SEARCH : return !this.collapsedSections.search;
					case this.S_SMTYPE : return !this.collapsedSections.smType;
					case this.S_PRICE : return !this.collapsedSections.price;
					case this.S_CAT : return !this.collapsedSections.cat;
				}
			},
			setAppropriateMode(mobile) {
				var prevWidth = this.mobileOptions.prevWidth;
				var curWidth  = this.mobileOptions.curWidth;

				if (mobile) {
					//console.log(`mobile (${prevWidth} -> ${curWidth})`);
					this.mobileOptions.mobileMode = true;
					this.mobileOptions.showFilterButton = true;
					this.mobileOptions.showResultsButton = false;
					this.mobileOptions.showSearchControls = false;
					this.mobileOptions.showSearchResults = true;
				} else { // desktop
					//console.log(`desktop (${prevWidth} -> ${curWidth})`);
					this.mobileOptions.mobileMode = false;
					this.mobileOptions.showFilterButton = false;
					this.mobileOptions.showResultsButton = false;
					this.mobileOptions.showSearchControls = true;
					this.mobileOptions.showSearchResults = true;
				}
			},
			switchToAppropriateMode() {
				var prevWidth = this.mobileOptions.prevWidth;
				var curWidth  = this.mobileOptions.curWidth;
				var toMobile  = ((curWidth < MOBILE_BP) && (prevWidth >= MOBILE_BP));
				var toDesktop = ((curWidth >= MOBILE_BP) && (prevWidth < MOBILE_BP));

				if (toMobile) {
					this.setAppropriateMode(true);
				} else if (toDesktop) {
					this.setAppropriateMode(false);
				}
			},
			initAppropriateMode() {
				var mobile = (this.mobileOptions.curWidth < MOBILE_BP);
				this.setAppropriateMode(mobile);
			},
			showFiltersButtonClicked() {
				this.mobileOptions.showFilterButton = false;
				this.mobileOptions.showResultsButton = true;
				this.mobileOptions.showSearchControls = true;
				this.mobileOptions.showSearchResults = false;
			},
			showResultsButtonClicked() {
				this.mobileOptions.showFilterButton = true;
				this.mobileOptions.showResultsButton = false;
				this.mobileOptions.showSearchControls = false;
				this.mobileOptions.showSearchResults = true;
			},
			notZero(count) {
				return (count > 0);
			},
			containsNonZero(...numbers) {
				return numbers.some(number => number !== 0);
			},
			notZeroBundlesInEach(bundleCategories) {
				var sum = 0;

				for (var i = 0; i < bundleCategories.length; i++) {
					var bundleCategory = bundleCategories[i];
					sum += this.getNrBundles(bundleCategory);
				}

				return sum;
			},
			getNrBundles(bundleCategory) {
				return bundleCategory?.nrBundles ?? 0;
			},
			clearFilters() {
				var ps                = this.bundleSearch;
				ps.and                = true;
				ps.discounted         = false;
				ps.free               = false;
				ps.socialMediaTypes = [];
				ps.bundleCategoryIDs  = [];
				ps.bundleTypes        = [];
				ps.searchTerm         = '';
			}
		},
		computed: {
			visibleImageCount() {
				return this.mobileOptions.curWidth >= 1200 ? 3 : this.mobileOptions.curWidth >= 992 ? 2 : 1;
			},
			smInstagram() {
				return this.enumSocialMediaType?.byName?.instagram?.value ?? 0;
			},
			smFacebook() {
				return this.enumSocialMediaType?.byName?.facebook?.value ?? 0;
			},
			hasAccount() {
				return this.oVisitorStatus.hasAccount;
			},
			isLoggedIn() {
				return this.oVisitorStatus.isLoggedIn;
			},
			disableControls() {
				return this.initialLoading || this.loadingError;
			},
			filtersCleared() {
				var ps = this.bundleSearch;

				return (ps)
					? (ps.and && !ps.discounted && !ps.free && ps.socialMediaTypes.length == 0 && ps.bundleCategoryIDs.length == 0 && ps.bundleTypes.length == 0 && ps.searchTerm == '')
					: true;
			},
			filtersNotCleared() {
				return !this.filtersCleared;
			},
			pageIndexNotZero() {
				return ((this.bundleSearch?.pageIndex ?? 0) != 0);
			},
			nonZeroResults() {
				var nrBundles = (this.oBundles?.length ?? 0);
				return (nrBundles > 0);
			},
			hasVisibleFilterSections() {
				return this.containsNonZero(this.bundleCounts.instagram, this.bundleCounts.facebook)
					|| this.containsNonZero(this.bundleCounts.discounted, this.bundleCounts.free)
					|| this.notZeroBundlesInEach(this.bundleCategories);
			},
		},
		watch: {
			'pageOptions.pageSize'(newVal, oldVal) {
				this.bundleSearch.pageSize = newVal;
			},
			'pageOptions.pageIndex'(newVal, oldVal) {
				this.bundleSearch.pageIndex = newVal;
			},
			'mobileOptions.curWidth'(newVal, oldVal) {
				this.mobileOptions.prevWidth = oldVal;
				this.switchToAppropriateMode();
			}
		}
	}
</script>




<style scoped>
	[v-cloak] {
		display: none;
	}

	#main {
		max-width: 1600px;
		margin: auto;
	}

	.search-controls {
		border: 0px solid black;
		width: 250px;
		width: 75%;
		margin : 0px auto;
		padding : 0px 0px;
	}

	.search-input:focus {
		box-shadow: 0 0 0 0.25rem rgba(67, 56, 202, 0.25);
		border:1px solid rgb(206, 212, 218);
	}

	.language-select:focus {
		box-shadow: 0 0 0 0.25rem rgba(67, 56, 202, 0.25);
		border:1px solid rgb(206, 212, 218);
	}

	.search-results {
		border: 0px solid black;
		margin-top:25px;
		position:relative;
		min-height:250px;
	}

	.search-results::before {
		content: "";
		background: #e0e7ff;
		position: absolute;
		width: 75%;
		border-radius: 20px;
		top: 0px;
		left: 0px;
		right: 0px;
		margin: auto;
		height: 100%;
		z-index: -1;
	}

	.control-section {
		border: 0px solid gray;
		padding: 12px 12px;
		background: #e0e7ff;
		position:relative;
	}

	.control-section:first-child {
		margin-top:0px;
	}

	.control-section-top {
		border-top-left-radius:20px;
		border-top-right-radius:20px;
	}

	.control-section-top.control-section-only {
		border-bottom-left-radius:20px;
		border-bottom-right-radius:20px;
	}

	.control-section-middle {
	}

	.control-section-bottom {
		border-bottom-left-radius:20px;
		border-bottom-right-radius:20px;
	}

	.control-section-middle::before, .control-section-bottom::before {
		content: "";
		background: #32658b;
		position: absolute;
		top: 0px;
		left: 10px;
		right: 10px;
		height: 1px;
	}

	.control-header {
		font-weight: bold;
		margin-bottom: 5px;
	}

	.control-section-controls {
		margin-top:0.5rem;
	}

	.filter-switch-section {
		border:2px solid rgb(67,56,202);
		background: rgb(224,231,255);
		border-radius: 20px;
		display:flex;
		align-items:center;
		justify-content:center;
		padding:4px;
		cursor:pointer;
	}

	.filter-switch-section img.svg-loader {
		height: 24px;
	}

	.filter-switch-section img.svg-filter {
		height: 14px;
	}

	.filter-switch-section span {
		margin-left:5px;
	}

	.show-results-section {
		background: rgb(67,56,202);
		border-radius: 20px;
		display:flex;
		align-items:center;
		justify-content:center;
		padding:4px;
		position:fixed;
		width:80%;
		bottom:2.5%;
		left:50%;
		transform:translateX(-50%);
		z-index:1000;
		color:white;
		font-size:1rem;
		cursor:pointer;
		padding:8px;
	}

	.show-results-section:hover {
		background: rgb(57,48,172);
	}

	.show-results-section img.svg-loader {
		height:24px;
	}

	.show-results-section span {
		margin-left:5px;
	}

	.form-label {
		font-weight: bold;
		display:block;
		position:relative;
		cursor:pointer;
		margin-bottom:0px;
	}

	.form-label::after {
		background: url(../img/gfx/chevron_black.svg) no-repeat center/6px 10px;
		content: "";
		height: 10px;
		margin-top: -5px;
		position: absolute;
		right: 0;
		top: 50%;
		transform: rotate(-90deg);
		width: 10px;
	}

	.form-label.collapsed {
		opacity:0.5;
	}

	.form-label.collapsed::after {
		transform: rotate(90deg);
		opacity:0.5;
	}

	.form-check input, .form-check label {
		cursor: pointer;
	}

	.row-paginator-top {
		margin-top:20px;
		margin-bottom:0px;
	}

	.row-paginator-bottom {
		margin-top:20px;
		margin-bottom:30px;
	}

	.row-main {
		margin: 0;
	}

	@media all and (min-width: 768px)
	{
		.search-controls {
			width: 250px;
			margin : 0px 0px;
			padding : 0px 12px;
		}

		.control-section:first-child {
			margin-top:0px;
		}

		.search-results {
			margin-top:0px;
			min-height:280px;
			align-self:flex-start;
		}
	}




	/* OVERLAY */

	.overlay {
		position:absolute;
		top:0px;
		left:0px;
		width:100%;
		height:100%;
	}

	.overlay-bg {
		position:absolute;
		top:0px;
		left:0px;
		width:100%;
		height:100%;
		background:black;
		opacity:0.1;
		z-index:10;
		border-radius:20px;
	}

	.overlay-img {
		position:absolute;
		top:0px;
		left:0px;
		width:100%;
		height:100%;
		z-index:20;
		display:flex;
		align-items:center;
		justify-content:center;
		border-radius:20px;
	}

	.overlay-img img {
		width:52px;
		height:52px;
	}

	/* OVERLAY */




	/* BUNDLE */

	.row-container-bundles {
		position:relative;
	}

	.col-container-bundle {
		border:0px solid black;
		margin-bottom: 50px;
	}

	.container-bundle {
		border: 1px solid transparent;
		border-radius: 15px;
		padding: 0px 13px;
		background: white;
		margin-top:50px;
	}

	.bundle-thumb {
		border: 0px solid purple;
		margin-top: -20px;
		position:relative;
	}

	.bundle-thumb img.bundle-image {
		object-fit: contain;
		width: 100%;
		height: 100%;
		border-radius: 15px;
	}

	.bundle-new-badge {
		position: absolute;
		top: -25px;
		left: -35px;
		width: clamp(70px, 21%, 92px);
		aspect-ratio: 1;
		transform: rotate(-20deg);
		filter: drop-shadow(0px 8px 8px rgba(15, 23, 42, 0.22));
		pointer-events: none;
		z-index: 3;
	}

	.bundle-new-badge img {
		display: block;
		width: 100%;
		height: 100%;
	}

	.bundle-new-badge span {
		position: absolute;
		inset: 0;
		display: flex;
		align-items: center;
		justify-content: center;
		padding-top: 1px;
		color: rgb(67, 56, 202);
		font-size: clamp(0.88rem, 2.6vw, 1.2rem);
		font-weight: 900;
		line-height: 1;
		text-align: center;
		text-shadow: 0px 1px 0px rgba(255, 255, 255, 0.62);
		transform: translate(5%, 0%);
	}

	.bundle-thumb img.icon-social-media {
		width:7.5%;
		position:absolute;
		bottom:3%;
		left:3%;
		opacity:1;
	}

	.bundle-thumb img.icon-content-type {
		width:7.5%;
		position:absolute;
		bottom:3%;
		right:3%;
		opacity:1;
	}

	.bundle-title {
		border: 0px solid red;
		display: flex;
		justify-content: center;
		margin-top: 4px;
	}

	.bundle-title span {
		font-weight: bold;
	}

	.bundle-discount {
		display: flex;
		justify-content: center;
		align-content: center;
		font-weight: bold;
		margin-top: 0px;
		color: red;
		text-align: center;
	}

	.bundle-icons {
		border: 0px solid green;
		display: flex;
		justify-content: space-between;
	}

	.bundle-icon {
		border: 0px solid cyan;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.bundle-icon span {
		margin-left: 10px;
	}

	.bundle-cta-button {
		border: 0px solid black;
		display: flex;
		justify-content: center;
		margin: 5px auto -25px auto;
	}

	.cta-button {
		border: 0px solid black;
		height: 50px;
		color: white;
		font-size: 1.2em;
		font-weight: normal;
		padding: 10px 25px;
		transition: 0.15s;
	}

	.cta-button:hover {
		/* background: #1299FD; */
	}

	.cta-button:focus, .cta-button:active {
		outline: none !important;
		box-shadow: none !important;
	}

	a.stylless-link {
		color: inherit;
		text-decoration: inherit;
	}

	.shadow {
		-webkit-box-shadow: 0px 7px 20px -6px rgba(0,0,0,0.25);
		-moz-box-shadow: 0px 7px 20px -6px rgba(0,0,0,0.25);
		box-shadow: 0px 7px 20px -6px rgba(0,0,0,0.25);
	}

	.grow {
		transition: all .3s ease;
	}

	.grow:hover {
		transform: scale(1.03);
	}

	@media all and (max-width: 991px) {
		.grow:hover {
			transform: scale(1.03);
		}
	}

	/* BUNDLE */

</style>

<style>
	/* Shared by the Razor placeholder and Vue's identical loading markup. */
	.catalogue-shell { max-width: 1600px; margin: auto; min-height: calc(100svh - 130px); }
	.catalogue-loading-row { margin: 0; }
	.catalogue-loading-filters { width: 75%; margin: 0 auto; padding: 0; }
	.catalogue-loading-filter-mobile { height: 36px; border: 2px solid #4338ca; border-radius: 20px; background: var(--cb-placeholder-surface); text-align: center; line-height: 32px; }
	.catalogue-loading-filter-desktop { display: none; padding: 12px; border-radius: 20px; background: var(--cb-placeholder-surface); min-height: 580px; }
	.catalogue-loading-results { margin-top: 25px; position: relative; }
	.catalogue-loading-results::before { content: ""; background: var(--cb-placeholder-surface); position: absolute; width: 75%; border-radius: 20px; inset: 0; margin: auto; z-index: -1; }
	.catalogue-paginator { min-height: 74px; }
	.catalogue-loading-pagination { margin-top: 20px; }
	.catalogue-loading-card { margin: 50px 0; padding: 0 13px; border: 1px solid transparent; border-radius: 15px; background: white; }
	.catalogue-loading-image { aspect-ratio: 500 / 333; margin-top: -20px; background: var(--cb-placeholder-fill); border-radius: 15px; }
	.catalogue-loading-line { height: 24px; width: 80%; margin: 8px auto; border-radius: 6px; background: var(--cb-placeholder-fill); }
	.catalogue-loading-price { width: 60%; height: 38px; margin-bottom: -25px; background: var(--cb-placeholder-accent); }
	.catalogue-shell .filter-switch-section { min-height: 36px; }
	@media (min-width: 768px) {
		.catalogue-loading-filters { width: 250px; margin: 0; padding: 0 12px; }
		.catalogue-loading-filter-mobile { display: none; }
		.catalogue-loading-filter-desktop { display: block; }
		.catalogue-loading-results { margin-top: 0; }
	}
</style>



